<template>
    <div>
        <div class="wrapper">
            <div class="animated fadeIn">
                <b-row>
                    <b-col cols="12" class="mb-3">
                        <b-button variant="primary" @click="$router.push('/admin/campaign-actions/toevoegen')" class="pull-right">Actie inplannen</b-button>
                    </b-col>
                </b-row>
                <resource-index header="Mijn acties" endpoint="campaign-actions" show-route="campaign-actions.view"/>
            </div>
        </div>
    </div>
</template>

<script>
    import ResourceIndex from '../../components/ResourceIndex';

    export default {
        name: 'campaign-actions',
        components: {ResourceIndex},
        computed: {
            userRole () {
                return this.$store.state.userRole
            }
        },
    }
</script>
